<template>
  <div class="container_inner_main">


    <div>
      <div class="style_contain_inputs">
        <div class="simple_title">
          旧密码
        </div>
        <el-input type="password" show-password class="simple_text" placeholder="旧密码"
                  v-model="personPSW.oldPassword">
        </el-input>
      </div>

      <div class="style_contain_inputs">
        <div class="simple_title">
          新密码
        </div>
        <el-input type="password" show-password class="simple_text" placeholder="新密码"
                  v-model="personPSW.password">
        </el-input>
      </div>


      <div class="style_contain_inputs">
        <el-button type="primary" @click="confirmReset">保存</el-button>

      </div>

    </div>

  </div>
</template>

<script>
import {changePSW, changePW} from "@/api/api";
import {Message} from "element-ui";

export default {
  name: "personal",
  data() {
    return {

      personPSW: {
        oldPassword: '',
        password: ''
      },
      roleList: [],
      disabled: true,
    }
  },
  created() {
    this.personPSW = {
      oldPassword: '',
      password: ''
    }
  },
  methods: {
    ritialInfo() {

    },


    confirmReset() {
      if (!this.checkEmpty(this.personPSW.oldPassword)) {
        this.$message.warning("请输入旧密码")
        return
      }
      if (!this.checkEmpty(this.personPSW.password)) {
        this.$message.warning("请输入新密码")
        return
      }
      if (this.personPSW.password === this.personPSW.oldPassword) {
        this.$message.warning("请勿提交相同密码")
        return;
      }
      this.$confirm('此操作将修改用户密码，需要重新登录，是否继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.restPSW()
      }).catch(() => {

      })
    },

    checkEmpty(val) {
      return val != null && val !== '' && (val + '').length > 0
    },
    restPSW() {
      changePW(this.personPSW).then(res => {
        if (res.data.code === '0000') {
          this.$router.push('/login');
        } else {
          Message.warning(res.data.message);
          if (res.data.code==='10007'){
            this.$router.push('/login');
          }
          // this.$message.warning(res.data.message)
        }
      })
    },

  }
}
</script>

<style scoped>
.container_inner_main {

}

.style_contain_inputs {
  display: flex;
  align-items: center;
  margin: 20px;
}

.simple_text {
  width: 500px;
  font-size: 18px;
  margin: 10px;
}

.simple_title {
  width: 160px;
  font-size: 18px;
}


</style>
